import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { ApiService } from '../../../../api/api.service' 
import { Router } from '@angular/router'
import { ToastMessageOptions} from 'primeng/api'
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-provider-arr-time-update',
    templateUrl: './provider-arr-time-update.component.html',
    styleUrls: ['./provider-arr-time-update.component.css'],
    standalone: false
})
export class ProviderArrTimeUpdateComponent implements OnInit {
  arrivalTime: any;
  arrivalDate: any;
  set_date: string;
  caseNumber: number;
  messages: ToastMessageOptions[];
  offset: number;
  
  @Output()
  saved: EventEmitter<boolean>

  constructor(private api:ApiService,
    private translate: TranslateService,
    private router: Router) { 
      this.saved = new EventEmitter();
  }

  ngOnInit() {
    const this_url =  this.router.url;
    const params = this_url.split("/")
    this.caseNumber = parseInt(params[4])
    this.offset = new Date().getTimezoneOffset();
  }
  onSelectday(date){
    //
    this.arrivalDate = date
  }
  onSelectTime(){
    this.set_date = this.arrivalDate + ' ' + this.arrivalTime
    //
  }
  onSubmit(){
    this.messages = [];
    //
    
    
    

    this.api.updateDate.postDate(this.set_date,this.caseNumber, this.offset)
    .promise()
    .then(b => {
      this.arrivalTime = null;
      this.arrivalDate = null;
      this.set_date = null;
      this.offset = null;
      this.caseNumber = null;
      if (b["status"]==200) {
        this.saved.emit(true)
      } else {
        this.saved.emit(false)
      }
    })
  }

}
